import { navigate } from 'gatsby';
import { useContext } from 'react';
import { StormModeInterceptContext } from '../../../providers/StormModeInterceptProvider';
import ROUTES from '../../../routes';
import { getFromStorage, setInStorage } from '../../../util/storage-utils';

export const STORM_MODE_INTERCEPT_STORAGE_KEY = 'stormModeInterceptStorageKey';

export function useStormModeIntercept() {
  const localStorageValue = getFromStorage(STORM_MODE_INTERCEPT_STORAGE_KEY);
  const isBrowser = !(typeof window === 'undefined');
  const currentPath = isBrowser && window.location.pathname;

  const { stormModeInterceptModal, setStormModeInterceptModal } = useContext(
    StormModeInterceptContext,
  );

  const handleSelection = (selection: 'yes' | 'no') => {
    setInStorage(STORM_MODE_INTERCEPT_STORAGE_KEY, selection);

    const url =
      selection === 'yes'
        ? ROUTES.OUTAGES
        : selection === 'no'
        ? stormModeInterceptModal?.defaultRedirectUrl
        : ROUTES.ACCOUNT;

    if (currentPath === url) {
      window.location.reload();
    }

    void navigate(url, {
      replace: true,
      state: stormModeInterceptModal?.locationState,
    });

    setStormModeInterceptModal({
      open: false,
      defaultRedirectUrl: ROUTES.ACCOUNT,
      locationState: undefined,
    });
  };

  return {
    handleSelection,
    localStorageValue,
  };
}
